/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Layout, Menu, MenuProps, Popover } from "antd";
// import Avatar from '../../../../src/assets/images/user.png';
import { MenuOutlined, UserOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/app";
// import { ReactComponent as LeftArrow } from "../../../../assets/images/icon/left-arrow-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { doLogout } from "../../../store/AuthSlice";
import LogoComponent from "../Components/LogoComponent";
// import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';

const HeaderView: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const Auth = useSelector((state: RootState) => state.AUTH);
  const navigate = useNavigate();
  const location = useLocation();
  const [userNameState, setUserNameState] = useState<string>("");
  const [current, setCurrent] = useState("/action?action=Start");

  const token = localStorage.getItem("token");

  useEffect(() => {
    setCurrent(location?.pathname);
  });

  const items: MenuProps["items"] = [
    {
      label: "Dashboard",
      key: "/dashboard",
    },
    {
      label: "Action",
      key: "/action?action=Start",
      children: [
        {
          label: "Start Portability",
          key: "/action?action=Start",
        },
        {
          label: "Inquire Ownership Number",
          key: "/action?action=Inquire_number",
        },
        {
          label: "Publish",
          key: "/action?action=Publish",
        },
        {
          label: "Add Portability Number",
          key: "/action?action=Add_portability_number",
        },
        {
          label: "Asterisk Number",
          key: "/asterisk-number",
        },

        {
          label: "Internal Number Routing",
          key: "/internal-number-routing",
        },
        {
          label: "Paycall Number Management",
          key: "/number-management",
        },
      ],
    },
    {
      label: "Customer",
      key: "Customer",
      children: [
        {
          label: "Company Management",
          key: "/company-management",
        },
        {
          label: "Company Number Management",
          key: "/company-number-management",
        },
        {
          label: "SIM Management",
          key: "/sim-management",
        },
      ],
    },

    {
      label: "Reports",
      key: "reports",
      children: [
        {
          label: "Publish Reports",
          key: "/publish-report",
        },
        {
          label: "Porting Reports",
          key: "/porting-report",
        },
        {
          label: "In Portability Reports",
          key: "/internal-report",
        },
        {
          label: "Out Portability Reports",
          key: "/external-report",
        },
        {
          label: "Soap Reports",
          key: "/soap-report",
        },
        {
          label: "Number Management Number Attributes Report",
          key: "/number-attributes-report",
        },
        {
          label: "Total Number Management By Attributes Report",
          key: "/total-number-by-attribs-report",
        },
        {
          label: "Asterisk Number By Shadow Prefix Reports",
          key: "/asterisk-number-by-shadow-prefix",
        },
        {
          label: "Number Management Internal Ported Numbers",
          key: "/internal-ported-numbers",
        },
        {
          label: "Ported Out From Us Reports",
          key: "/ported-out-from-us-report",
        },
      ],
    },
    {
      label: "Emails",
      key: "Emails",
      children: [
        {
          label: "Send Email Support",
          key: "/support",
        },
      ],
    },
    {
      label: "Settings",
      key: "Settings",
      children: [
        {
          label: "Users",
          key: "/users",
        },
        {
          label: "Portability Providers",
          key: "/providers",
        },
        {
          label: "Asterisk Providers",
          key: "/star-providers",
        },
        {
          label: "Email Network Providers",
          key: "/network-providers",
        },
        {
          label: "Email NOC Providers",
          key: "/noc-providers",
        },
        {
          label: "Email Support Providers",
          key: "/support-providers",
        },
        {
          label: "Portability Error Codes",
          key: "/error-codes",
        },
        {
          label: "Portability Webhooks",
          key: "/webhooks",
        },
      ],
    },
    // {
    //   label: <span onClick={() => logout()}>Logout</span>,
    //   key: '',
    // },
  ];

  // call logout function
  const logout = () => {
    localStorage.clear();
    navigate("/login");
    const payload = {
      token: token,
    };
    dispatch(doLogout(payload))
      .then(() => {
        navigate("/login");
      })
      .catch((error: any) => {
        console.log("error", error);
      });
  };
  // const content = (
  //   <div className="profileDropdown">
  //     <div className="greeting">
  //       Welcome
  //       <br />
  //       <strong>{Auth?.useName !== '' ? Auth?.useName : userNameState}</strong>
  //     </div>
  //     <ul className="menu">
  //       <li>
  //         <Link to="/profile">Profile</Link>
  //       </li>
  //       <li onClick={() => logout()}>Logout</li>
  //     </ul>
  //   </div>
  // );

  useEffect(() => {
    const userDetails = localStorage.getItem("userDetails");
    const userName = userDetails && JSON.parse(userDetails)?.full_name;
    userName && setUserNameState(userName);
  }, []);

  const onClick: MenuProps["onClick"] = (e) => {
    navigate(e.key);
    setCurrent(e.key);
  };

  const content = (
    <div className="profileDropdown">
      <div className="greeting">
        Welcome
        <br />
        <strong>{Auth?.useName !== "" ? Auth?.useName : userNameState}</strong>
      </div>
      <ul className="menu">
        {/* <li>
          <Link to="/profile">Profile</Link>
        </li> */}
        <li onClick={() => logout()}>Logout</li>
      </ul>
    </div>
  );
  return (
    <Layout.Header className="main__page__appheader">
      <div className="headerWrap">
        <div className="appheader__left">
          <LogoComponent />
        </div>
        <div className="appheader__right">
          <Menu
            onClick={onClick}
            selectedKeys={[current]}
            mode="horizontal"
            items={items}
            className="mainMenu"
            inlineCollapsed={false}
            overflowedIndicator={<MenuOutlined />}
          />
          {/* <div className='userName'>Welcome, {userNameState}.</div> */}
          <div className="userDropdown">
            <Popover
              content={content}
              trigger="hover"
              placement="bottomLeft"
              arrow
              overlayClassName="userMenuList"
            >
              <div className="userMenuWrap">
                <span className="avatar">
                  <UserOutlined />
                </span>
              </div>
            </Popover>
          </div>
          {/* <div className="userDropdown">
            <Popover
              content={content}
              trigger="hover"
              placement="bottomRight"
              arrow
              overlayClassName="userMenuList"
            >
              <div className="userMenuWrap">
                <span className="avatar">
                  <UserOutlined />
                </span>
              </div>
            </Popover>
          </div> */}
        </div>
      </div>
    </Layout.Header>
  );
};

export default HeaderView;
